import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";

@Component
export class QualificationDetailsBase extends Vue {
    @Prop()
    id!: string;

    @Prop({default: true})
    showMetadata!: boolean;
    
}
